<template>
  <DragDialog
    title="详情"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="basic-info-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">基本信息</div>
      </div>
      <div class="content-box">
        <div class="left-box">
          <div class="item-box">
            <div class="label-box dialog-label">路由名称：</div>
            <div
              class="value-box text-overflow dialog-label"
              :title="apiInfo.url">
              {{ apiInfo.url }}
            </div>
          </div>
          <div class="item-box">
            <div class="label-box dialog-label">用户名：</div>
            <div class="value-box dialog-label">
              {{ apiInfo.userName }}
            </div>
          </div>
          <div class="item-box">
            <div class="label-box dialog-label">客户端IP地址：</div>
            <div class="value-box dialog-label">
              {{ apiInfo.clientIpAddress }}
            </div>
          </div>
          <div class="item-box">
            <div class="label-box dialog-label">浏览器类型：</div>
            <div
              class="value-box browser-info two-line-text-overflow dialog-label"
              :title="apiInfo.browserInfo">
              {{ apiInfo.browserInfo }}
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="item-box">
            <div class="label-box dialog-label">请求方式：</div>
            <div class="value-box dialog-label">
              {{ apiInfo.httpMethod }}
            </div>
          </div>
          <div class="item-box">
            <div class="label-box dialog-label">请求状态：</div>
            <div class="value-box dialog-label">
              {{ apiInfo.httpStatusCode }}
            </div>
          </div>
          <div class="item-box">
            <div class="label-box dialog-label">请求发起时间：</div>
            <div class="value-box dialog-label">
              {{
                apiInfo.executionTime ? formatTime(apiInfo.executionTime) : '--'
              }}
            </div>
          </div>
          <div class="item-box">
            <div class="label-box dialog-label">请求时长(ms)：</div>
            <div class="value-box dialog-label">
              {{ apiInfo.executionDuration }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="request-details-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">请求明细</div>
      </div>
      <div class="common-table-box">
        <el-table
          ref="table"
          highlight-selection-row
          class="publish-table"
          :data="detailsList"
          height="100%"
          :header-row-class-name="customHeader">
          <el-table-column
            label="序号"
            type="index"
            width="75" />
          <el-table-column
            label="服务名称"
            prop="serviceName">
            <template v-slot="{ row }">
              <div
                class="two-line-text-overflow"
                :title="row.serviceName">
                {{ row.serviceName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="方法名"
            prop="methodName"
            width="220" />
          <el-table-column label="请求参数">
            <template v-slot="{ row }">
              <div class="params-column-box">
                <div>{{ row.parameters }}</div>
                <div
                  class="copy"
                  data-clipboard-action="copy"
                  :data-clipboard-text="row.parameters"
                  @click="copyParams">
                  复制
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="请求时间"
            width="200">
            <template v-slot="{ row }">
              <div>
                {{ row.executionTime ? formatTime(row.executionTime) : '--' }}
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">没有找到相关内容</template>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import Clipboard from 'clipboard'
import DragDialog from '@/components/CustomDragDialog.vue'

import { formatTime } from '@/utils/generalMethods'

import { getStatisticsDetailsService } from '@/service/interface'
export default {
  data() {
    return {
      detailsList: [],
      customHeader: ''
    }
  },
  props: {
    visible: Boolean,
    apiInfo: Object,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initApiDetails()
      }
    }
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.table?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 1500)
    let copybtn = document.getElementsByClassName('copy')
    this.clipboard = new Clipboard(copybtn)
  },
  methods: {
    initApiDetails() {
      this.queryApiDetails().then(detailsList => {
        this.detailsList = detailsList

        this.$nextTick(() => {
          this.initClipboard()
        })
      })
    },
    initClipboard() {
      let copybtn = document.getElementsByClassName('copy')
      this.clipboard = new Clipboard(copybtn)
    },
    cancel() {
      this.detailsList = []
      this.closeDialog()
    },
    copyParams() {
      this.clipboard.on('success', () => {
        this.$message.success('复制成功！')
      })

      this.clipboard.on('error', () => {
        this.$message.error('复制失败，请手动复制！')
      })
    },
    queryApiDetails() {
      return new Promise(resolve => {
        let params = {
          auditLogId: this.apiInfo.id
        }
        getStatisticsDetailsService(params).then(response => {
          if (response.isSuccess) {
            let detailsList = response.data
            resolve(detailsList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
.title-box {
  display: flex;
  align-items: center;

  .symbol {
    width: 4px;
    height: 20px;
    background: var(--base-primary-bgColor);
  }

  .title {
    margin-left: 10px;
  }
}

.two-line-text-overflow {
  display: -webkit-box;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.5em;
}

.basic-info-box {
  color: var(--default-color);

  .content-box {
    display: flex;
    margin: 10px 0px;
    padding: 10px 20px;
    font-size: 14px;

    .item-box {
      display: flex;
      line-height: 30px;

      .label-box {
        flex-shrink: 0;
        width: 110px;
        text-align: right;
      }
    }

    .left-box {
      width: 60%;
      overflow: hidden;

      .browser-info {
        margin-top: 5px;
      }
    }

    .right-box {
      margin-left: 40px;
      flex-grow: 1;
    }
  }
}

.request-details-box {
  color: var(--default-color);

  .common-table-box {
    height: 360px;
    margin-top: 10px;

    /deep/ .el-table {
      .el-table__cell {
        position: relative;

        .params-column-box {
          padding: 15px 5px;
          &:hover {
            background: rgba(217, 217, 217, 0.06);

            .copy {
              display: block;
            }
          }

          .copy {
            display: none;
            position: absolute;
            right: 10px;
            top: 0px;
            font-size: 12px;
            padding: 1px 13px;
            border-radius: 5px;
            color: var(--api-details-copy-btn-color);
            background: var(--api-details-copy-btn-bgColor);
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
